import {
    LOAD_POS_SETTINGS_SUCCESS,
    UPDATE_POS_SETTINGS_SUCCESS,
    CLEAR_POS_SETTINGS } from '../../../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case LOAD_POS_SETTINGS_SUCCESS:
			return action.payload;
        case UPDATE_POS_SETTINGS_SUCCESS:
            return action.payload;
        case CLEAR_POS_SETTINGS:
            return INITIAL_STATE;
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/restaurants/settings/pos/PosSettingsReducer.js